<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('INDEX.amz_sku_inv_fty_query_search') ||
                  'SKU/产品名/品牌 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportFile"
              v-if="allow('P')"
            >
              {{ $l('INDEX.btn_export') || '导出' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.amz_sku_inv_query_amzSkuNo') || '产品SKU'"
            >
              <el-input v-model="form.amzSkuNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.amz_sku_inv_query_brandCode') || '品牌'"
            >
              <dict-select
                v-model="form.brandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.amz_sku_inv_query_goodsName') || '中文名称'"
            >
              <el-input v-model="form.goodsName" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.amz_sku_inv_query_goodsNameEn') || '英文名称'"
            >
              <el-input v-model="form.goodsNameEn" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.amz_sku_inv_query_ncNo') || 'NC编码'"
            >
              <el-input v-model="form.ncNo" clearable size="small"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.amz_sku_inv_query_buyerCode') || '采购'"
            >
              <dict-select
                v-model="form.buyerCode"
                url="/master/common/dict/baseUserSelect"
                filterable
                clearable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.amz_sku_inv_query_scmCode') || '工厂'"
            >
              <dict-select
                v-model="form.scmCode"
                url="/master/common/dict/scmPartners"
                filterable
                clearable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="
                  $l('INDEX.amz_sku_inv_query_ftyInvUpdateTimeStart') ||
                    '国内库存更新时间'
                "
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.ftyInvUpdateTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.ftyInvUpdateTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="'库存数量'">
                <el-col :span="11">
                  <el-input-number
                    v-model="form.ftyInvQtyStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    controls-position="right"
                    style="width: 100%"
                    :precision="0"
                    :min="0"
                    :step="1"
                    step-strictly
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.ftyInvQtyEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    controls-position="right"
                    style="width: 100%"
                    :precision="0"
                    :min="0"
                    :step="1"
                    step-strictly
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="'库存金额'">
                <el-col :span="11">
                  <el-input-number
                    v-model="form.ftyInvAmountStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    controls-position="right"
                    style="width: 100%"
                    :precision="4"
                    :min="0"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.ftyInvAmountEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    controls-position="right"
                    style="width: 100%"
                    :precision="4"
                    :min="0"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '' }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', { ...this.form })
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    exportFile() {
      this.$emit('exportFile', this.form)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
